import { Controller } from 'react-hook-form'
import DatePicker from 'react-datepicker'
import { forwardRef } from 'react'
import { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import 'react-datepicker/dist/react-datepicker.css'
import './DatePickerStyles.css'
import { DateTime } from 'luxon'

// Enregistrer la locale française
registerLocale('fr', fr)

// Convertit une chaîne de date ou un objet Date en objet Date
const parseDate = (dateValue) => {
  if (!dateValue) return null
  
  if (typeof dateValue === 'string') {
    // Utiliser Luxon pour créer une date sans fuseau horaire
    const luxonDate = DateTime.fromISO(dateValue, { zone: 'UTC' })
    
    // Convertir en objet Date JavaScript pour react-datepicker
    return luxonDate.isValid ? luxonDate.toJSDate() : null
  }
  
  return dateValue
}

export default ({
  name,
  control,
  label,
  defaultValue = '',
  disabled = false,
  rules = {},
  validator = {},
  className = '',
}) => {
  // Composant personnalisé pour le DatePicker qui respecte le style DaisyUI
  const CustomInput = forwardRef(({ value, onClick, onChange, disabled, date}, ref) => (
      <input
        className="w-full"
        value={value || ''}
        onClick={onClick}
        onChange={onChange}
        ref={ref}
        disabled={disabled}
        // Suppression de readOnly pour permettre la saisie au clavier
      />
    )
  )
  
  CustomInput.displayName = 'CustomDateInput'

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => {
        // Conversion de la valeur string en objet Date si nécessaire
        const dateValue = parseDate(field.value)

        return (
          <div className="w-full">
            <label className={`input ${className} ${validator.hasError && validator.hasError(name) ? 'validator' : ''}`}
              {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
            >
              <span className="label">{label}</span>
              <DatePicker
                selected={dateValue}
                onChange={(date) => {
                  if (!date) {
                    field.onChange('')
                    return
                  }
                  
                  // Utiliser Luxon pour formater la date sans problème de fuseau horaire
                  const luxonDate = DateTime.fromJSDate(date)
                  const formattedDate = luxonDate.toFormat('yyyy-MM-dd')
                  field.onChange(formattedDate)
                }}
                onBlur={field.onBlur}
                customInput={<CustomInput disabled={disabled} date={dateValue} />}
                dateFormat="dd/MM/yyyy"
                disabled={disabled}
                className="w-full"
                locale="fr"
                placeholderText="Sélectionner une date"
                shouldCloseOnSelect={false}
                disabledKeyboardNavigation={false}
                allowSameDay={true}
                strictParsing={false}
                isClearable={true}
                todayButton="Aujourd'hui"
              />
            </label>
            {validator.getErrorMessage && (
              <div className="validator-hint hidden pt-4 empty:py-[0.6rem]">
                {validator.getErrorMessage(name)}
              </div>
            )}
          </div>
        )
      }}
    />
  )
}